import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsApplicationAreas(companyId, regulationId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_APPLICATION_AREA,dtConfig[ModulesMap.REGULATIONS_APPLICATION_AREA].getRegulationsApplicationAreas,
		{
			urlParams: {
				companyId,
				regulationId,
			},
		},
	)
}

function createRegulationsApplicationArea(companyId, regulationId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_APPLICATION_AREA,dtConfig[ModulesMap.REGULATIONS_APPLICATION_AREA].createRegulationsApplicationArea, {
		urlParams: {
			companyId,
			regulationId,
		},
		...data,
	})
}

function getRegulationsApplicationArea(companyId, regulationId, applicationAreaId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_APPLICATION_AREA,dtConfig[ModulesMap.REGULATIONS_APPLICATION_AREA].getRegulationsApplicationArea, {
		urlParams: {
			companyId,
			regulationId,
			applicationAreaId,
		},
	})
}

function patchRegulationsApplicationArea(companyId, regulationId, applicationAreaId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_APPLICATION_AREA,dtConfig[ModulesMap.REGULATIONS_APPLICATION_AREA].patchRegulationsApplicationArea, {
		urlParams: {
			companyId,
			regulationId,
			applicationAreaId,
		},
		...data,
	})
}

function putRegulationsApplicationArea(companyId, regulationId, applicationAreaId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_APPLICATION_AREA,dtConfig[ModulesMap.REGULATIONS_APPLICATION_AREA].putRegulationsApplicationArea, {
		urlParams: {
			companyId,
			regulationId,
			applicationAreaId,
		},
		...data,
	})
}

function deleteRegulationsApplicationArea(companyId, regulationId, applicationAreaId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_APPLICATION_AREA,dtConfig[ModulesMap.REGULATIONS_APPLICATION_AREA].deleteRegulationsApplicationArea, {
		urlParams: {
			companyId,
			regulationId,
			applicationAreaId,
		},
	})
}

export default {
	getRegulationsApplicationAreas,
	getRegulationsApplicationArea,
	patchRegulationsApplicationArea,
	putRegulationsApplicationArea,
	createRegulationsApplicationArea,
	deleteRegulationsApplicationArea,
}
